function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ondelivery_svg__a",
  x1: "50.147%",
  x2: "50.147%",
  y1: "100.155%",
  y2: "-.25%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#F69321"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#EF7700"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.571 16.133c1.578 0 2.858 1.314 2.858 2.934S25.149 22 23.57 22c-1.577 0-2.857-1.313-2.857-2.933 0-1.62 1.28-2.934 2.857-2.934zm.93-11.733c.753 0 1.45.406 1.838 1.068l3.355 5.743c.201.342.306.733.306 1.132v4.524c0 .81-.64 1.466-1.429 1.466h-.778c-.342-2.077-2.102-3.666-4.222-3.666-1.097 0-2.097.43-2.857 1.13V4.4zM17.857 0c.789 0 1.429.657 1.429 1.467v16.866H7.429c-.79 0-1.429-.657-1.429-1.466V11.44H2.571c-.472 0-.857-.394-.857-.88s.385-.88.857-.88h6c.474 0 .858-.394.858-.88s-.384-.88-.858-.88H.857A.869.869 0 010 7.04a.87.87 0 01.857-.88h12c.474 0 .857-.394.857-.88s-.383-.88-.857-.88H2.571c-.472 0-.857-.394-.857-.88s.385-.88.857-.88H6V1.467C6 .657 6.64 0 7.429 0zm6.729 5.867h-2.443V11h5.714l-2.651-4.764a.712.712 0 00-.62-.37z",
  fill: "url(#ondelivery_svg__a)",
  fillRule: "nonzero"
});

function SvgOndelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22
  }, props), _ref, _ref2);
}

export default SvgOndelivery;